<template>
  <v-container grid-list-xl fluid>     
    <v-layout row wrap>
      <v-flex x16>
        <v-card>
          <v-card-title>
            
            <v-text-field append-icon="search" label="Search" single-line v-model="searchContact"></v-text-field>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-btn 
              @click="downloadExcel"
              :loading="loadDownloadExcel"
              color="primary"
              dark
              class="mb-2"
            >
              Export Contacts
              <v-icon class="ml-2">get_app</v-icon>
            </v-btn>
            <!--
            <v-btn color="primary"
              dark
              class="mb-2"
            >
              New Contact
              <v-icon class="ml-2">person_add_alt_1</v-icon>
            </v-btn>
            -->
          </v-card-title>
          <contacts-table 
            :textSearch="searchContact"
            :contacts="contacts"
            :totalContacts="totalContacts"
            :loadContacts="loadContacts"
            @edit-contact="openModalContact()"
            @update-data="loadData"
          />
          <!--
          <modal-create-contact
            :show-modal="showModal.createContact"
            @close-modal-create="showModal.createContact = false"
            @add-contact="addContact"
          ></modal-create-contact>
          
          <modal-edit-contact
            v-if="selectedContact && showModal.editContact"
            :show-modal="showModal.editContact"
            :contactId="selectedContact.id"
            :index="index"
            @close-modal-edit="showModal.editContact = false"
            @update-contact="updateContact"
          ></modal-edit-contact>

          <modal-delete-contact
            v-if="selectedContact && showModal.deleteContact"
            :show-modal="showModal.deleteContact"
            :contact="selectedContact"
            @close-modal-delete="showModal.deleteContact = false"
            @delete-contact="deleteContact"
          ></modal-delete-contact>
          -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactsTable from '@/components/client/contacts/components/ContactsTable.vue';
import ModalCreateContact from '@/components/client/contacts/components/modals/CreateContact.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ContactsTable,
    ModalCreateContact
  },
  data () {
    return {
      searchContact: '',
      loadDownloadExcel: false,
      contacts: [],
      totalContacts: 0,
      loadContacts: false,
      
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    downloadExcel () {
      this.loadDownloadExcel = true;
      let url = `contacts/export-excel`;
      window.axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        this.loadDownloadExcel = false;
        let filename = `contacts-${this.currentUser.name}-${this.currentUser.id}.xlsx`;
        if (!window.navigator.msSaveOrOpenBlob) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
        }
      });
    },
    loadData (values) {
      this.loadContacts = true;
      let url = `contacts`;
      let params = {
        page: values.page,
        rows_per_page: values.rowsPerPage,
        sort_by: values.sortBy
      };
      if (this.searchContact !== '') {
        params.search = this.searchContact;
      }
      params.orientation = values.descending ? 'ASC' : 'DESC';
      window.axios.get(url, { params }).then((response) => {
        this.contacts = response.data.data;
        this.totalContacts = response.data.meta.total;
        this.loadContacts = false;
      });
    },
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/contacts/Page.vue